import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import { localize } from 'helpers/translator'

import Modalizer from 'components/modalizer/modalizer'
import { MainButton } from 'components/button'
import TextLink from 'components/text_link/text_link'
import privateLibraryActions from 'redux/actions/privateLibraryActions'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import styles from './unlock_lessons_modal.scss'
import headerImage from 'assets/views/experimental/image-header.svg'

class UnlockLessonsModal extends PureComponent {

	componentDidMount() {
		this.props.actions.unlockOverlayOpen(this.props.privateLibraryTitle)
	}

	render() {
		return (
			<Modalizer boxed={false} closeAction={() => {}} closeButton={false}>
				<div styleName='experiment-modal'>
					<header styleName='header'>
						<h1 styleName='header-title'>{localize('unlock_lessons_modal_title1')}</h1>
						<img styleName='header-image' src={headerImage} alt='' width='' height='' />
					</header>
					<section styleName='content'>
						<p styleName='content-text'>{localize('unlock_lessons_modal_message_part1')}<strong styleName='strong'>{localize('unlock_lessons_modal_message_part2')}</strong></p>
						<div styleName='content-button'>
							<div styleName='button-wrapper'><MainButton pill={true} size='big' onClick={() => this.props.actions.unlockSampleLessons(this.props.sampleLessonsRedirect)}>{localize('unlock_lessons_modal_button_text')}</MainButton></div>
						</div>
						<div styleName='content-link'>
							<TextLink onClick={() => this.props.actions.learnMorePackages(this.props.learnMoreRedirect)}>{localize('unlock_lessons_modal_textLink')}</TextLink>
						</div>
					</section>
				</div>
			</Modalizer>
		)
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		unlockOverlayOpen: privateLibraryActions.unlockOverlayOpen,
		unlockSampleLessons: privateLibraryActions.unlockSampleLessons,
		learnMorePackages: privateLibraryActions.learnMorePackages,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(CSSModules(UnlockLessonsModal, styles, {allowMultiple: true}))
